import posthog from "posthog-js";
import { isPostHogEnabled } from "@/config/posthog";

/**
 * Identify the current user to PostHog.
 * Call after OTP verification (registration) and on every successful login.
 * Merges the anonymous session into the identified person profile.
 */
export function identifyUser(
  userId: string | number,
  traits?: Record<string, unknown>,
): void {
  if (!isPostHogEnabled()) return;
  posthog.identify(String(userId), traits);
}

/**
 * Reset PostHog identity on logout.
 * Generates a new anonymous distinct_id for the next session.
 */
export function resetUser(): void {
  if (!isPostHogEnabled()) return;
  posthog.reset();
}
